import React from 'react';
import { gql, useQuery } from '@apollo/client';
import { CREATE_SCORE_FIELDS } from '../../../lib/queries/score.queries';
import { DRILL_FIELDS } from '../../../lib/queries/drill.queries';
import { SKILL_FIELDS } from '../../../lib/queries/skill.queries';
import { Box, CircularProgress, List, ListItem, ListItemText, Typography } from '@material-ui/core';
import _ from 'lodash';

const GET_EVALUATION_HISTORY = gql`
  query GetAssessmentSessionEvaluationHistory($_id: ID!) {
    assessmentSession(_id: $_id) {
      _id
      evaluationHistory {
        user {
          _id
          name
        }
        scores {
          ...CreateScoreFields
        }
        drills {
          ...DrillFields
        }
        skills {
          ...SkillFields
        }
      }
    }
  }

  ${CREATE_SCORE_FIELDS}
  ${DRILL_FIELDS}
  ${SKILL_FIELDS}
`;

interface IAssessmentSessionEvaluationHistoryGraphQL {
  assessmentSessionId: string;
}

export const AssessmentSessionEvaluationHistoryGraphQL: React.FC<IAssessmentSessionEvaluationHistoryGraphQL> = ({ assessmentSessionId }) => {
  const { data, loading } = useQuery(GET_EVALUATION_HISTORY, {
    variables: { _id: assessmentSessionId },
    fetchPolicy: 'cache-and-network'
  });

  const evaluationHistory = data ? data.assessmentSession.evaluationHistory as IEvaluatorEvaluationHistory[] : [];

  if (!evaluationHistory.length)
    if (loading) return <CircularProgress />
    else return <Typography>No data found</Typography>

  return (
    <Box>
      <List>
        {_.map(evaluationHistory, ({user, scores, drills, skills}) => {
          const uniquePlayers = _.uniq(scores.map((s) => String(s.playerAssessmentId)));

          return (
            <ListItem key={user._id}>
              <ListItemText primary={user.name} secondary={`${scores.length} scores across ${drills.length} drills, ${skills.length} skills, and ${uniquePlayers.length} players.`} />
            </ListItem>
          )
        })}
      </List>
    </Box>
  );
};
